import { Spinner } from 'reactstrap';
import { Table } from '@octano/global-ui';
import { StudyPlanVersionOffer } from '../types';
import { useColumns } from '../hooks/useColumns';

interface StudyPlanVersionOffersSectionProps {
  studyPlanVersionOffers: StudyPlanVersionOffer[];
  isLoading: boolean;
  disabled?: boolean;
  onInterviewRequiredChange?: (offerId: number, isRequired: boolean) => void;
}

export default function StudyPlanVersionOffersSection({
  studyPlanVersionOffers,
  isLoading,
  disabled = false,
  onInterviewRequiredChange,
}: StudyPlanVersionOffersSectionProps) {
  const columns = useColumns(onInterviewRequiredChange, disabled);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center p-4">
        <Spinner size="sm" />
      </div>
    );
  }

  return (
    <div>
      <Table
        data={studyPlanVersionOffers}
        columns={columns}
        striped
        notResponsive={false}
      />
    </div>
  );
}
